module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/weronika-piwowarska-8a2c54486e309bc23cb80c3e5bfe4dc5.png";